import { Action } from 'redux';

/**
 * Helper function to produces the right shape of a reducer action.
 */
export function action(type: string, payload: any = {}): Action {
    return {
        type,
        ...payload,
    };
}

/**
 * Dispatches a reset store action.
 * When this action gets dispatched, the whole redux store gets reset to it's initial state
 */
export const RESET_STORE = 'RESET_STORE';
export const resetStore = () => action(RESET_STORE);

/** R56-9: binds the store to the signed-in account (OIDC subject; null = nobody signed in). */
export const BIND_ACCOUNT_OWNER = 'BIND_ACCOUNT_OWNER';
export const bindAccountOwner = (subject: string | null) => action(BIND_ACCOUNT_OWNER, { subject });
